import classNames from 'classnames';
import React from 'react';
import { LISTING_HEAP_IDS } from '../../../constants';
import './ActionsPanel.scss';

type ActionsPanelProps = {
    isShareable: boolean;
};

export const ActionsPanel = ({ isShareable }: ActionsPanelProps) => {
    const panelItemsClassNames = classNames(
        'actions-panel__item eds-fx--fade-in-down',
        { 'eds-fx--duration-2 fx--delay-14': !isShareable },
        {
            'actions-panel__item--share eds-fx--duration-1 fx--delay-12':
                isShareable,
        },
    );

    return (
        <div className="actions-panel">
            <ul className="actions-panel__list">
                {isShareable && (
                    <li
                        data-heap-id={LISTING_HEAP_IDS.SHARE_EVENT}
                        className={panelItemsClassNames}
                    >
                        <span
                            id="listings-root__share-event-modal"
                            data-testid="listings-root__share-event-modal"
                        ></span>
                    </li>
                )}
                <li className={panelItemsClassNames}>
                    <span
                        id="listings-root__bookmark-desktop"
                        data-testid="listings-root__bookmark-desktop"
                    ></span>
                </li>
            </ul>
        </div>
    );
};
